import { AxiosRequestConfig } from 'axios';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const printBarcode = (userName: string, password: string): Promise<IReceipt[]> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'POST',
    url: '/auth/print-barcode',
    data: {
      userName,
      password
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: false,
  };

  return emeraldRequest(emeraldRequestParams);
};
